import React from 'react';
import { TorgaContext } from '../TorgaContext';
import { Browser, List, Page } from '../../utils/Layout/Layout';
import ObjectSelector from '../../utils/ObjectSelector/ObjectSelector';
import { ObjectTypes, urlToGoal, urlToGoalID } from '../TorgaRouter';
import Goal from './Goal';
import { actionGoalCreate } from './actions';
import { useNavigate } from 'react-router-dom';

export default function Routines() {
  const { state, dispatchAction } = React.useContext(TorgaContext);
  const [, setSearch] = React.useState('');
  const navigate = useNavigate();

  const goals = state.goals.allIDs.map((id) => state.goals.byID[id]);

  return (
    <Browser>
      <List>
        <ObjectSelector
          objects={goals}
          objectType={ObjectTypes.GOALS}
          urlToObject={urlToGoalID}
          onChange={setSearch}
          onCreate={() => {
            dispatchAction(
              actionGoalCreate('New Goal', null, (goal) => {
                navigate(urlToGoalID(goal.id), { state: { focusName: true } });
              })
            );
          }}
          onSelect={(id) => {
            navigate(urlToGoalID(id));
          }}
        />
      </List>

      <Page>
        <Goal />
      </Page>
    </Browser>
  );
}
